import { OrderDetails } from "../shared/types/dashboard";
import { parseNumber } from "./helpers";

export const calculatePopularItems = (orders: OrderDetails[]) => {
  const itemMap = new Map<string, { count: number; revenue: number }>();

  orders.forEach((order) => {
    order.Products?.forEach((product: { productName: any; quantity: number; amount: string | number | undefined }) => {
      if (!product?.productName) return;

      const name = product.productName;
      const quantity = product.quantity || 1;
      const amount = parseNumber(product.amount);
      const revenue = quantity * amount;

      const existing = itemMap.get(name) || { count: 0, revenue: 0 };
      itemMap.set(name, {
        count: existing.count + quantity,
        revenue: existing.revenue + revenue,
      });
    });
  });

  return Array.from(itemMap.entries())
    .map(([name, { count, revenue }]) => ({ name, count, revenue }))
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 5);
};
